import React, { useEffect } from "react";
import ReportTab from "./ReportTab";
import ReportDetails from "./ReportDetails";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import * as ConfigurationActions from "../../../store/configurationService/actions";

const Agreeableness = (props: any) => {
    const scoreDescription = {
        High: ["Accommodating", "Helpful", "Altruistic", "Sympathetic", "Selfless"],
        Moderate: ["Looks out for self and others", "Strategic", "Assertive", "Decisive", "Considerate"],
        Low: ["Direct", "Objective", "Self-Focused", "Competitive", "Argumentative"],
    };
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className=" row between-xs middle-xs">
                <div className="col-xs">
                    <h1 className="title-page" id={"title-page-" + props.name} tabIndex={-1}>
                        RepIQ™ Reputation Analyzer Report
                    </h1>
                </div>
            </div>

            <ReportTab selectedTab="1" />

            <div className="row" id="content">
                <div className="col-xs-12">
                    <div className="box">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-text has-actions">
                                    <h2 className="box-title">Agreeableness</h2>
                                </div>
                            </div>
                        </div>
                        <div className="box-content">
                            <div className="row">
                                <div className="col-xs-12 col-sm-9">
                                    <p>
                                        Agreeableness measures the degree of someone's helpful and trusting nature. Individuals who score high in Agreeableness
                                        experience a high level of empathy and typically enjoy taking care of others. They excel at working in teams because they
                                        are skilled at understanding others and harmoniously cooperating to reach a common goal.
                                    </p>
                                    <p>
                                        People who score low in Agreeableness tend to experience less empathy and put their own concerns ahead of others. Tasks
                                        involving collaboration can be frustrating to them, as they naturally strive to compete rather than cooperate.
                                    </p>
                                </div>
                                <div className="col-xs-12 col-sm-3">
                                    <div role="option" className="img-container">
                                        <img src="images/img-agreeableness.jpg" alt="Two men shaking hands" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ReportDetails title={"Agreeableness"} name={"Agreeableness"} scoreDescription={scoreDescription} />
                </div>
            </div>
        </React.Fragment>
    );
};
export default Agreeableness;
